import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ecf234d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cache_operate" }
const _hoisted_2 = { class: "cache_operate_main" }
const _hoisted_3 = { class: "cache_operate_right" }
const _hoisted_4 = { class: "main" }
const _hoisted_5 = { class: "mod_pagin" }

import { computed, reactive, ref, createVNode } from 'vue';
import { useRouter } from 'vue-router';
import { Key } from 'ant-design-vue/lib/_util/type';
import { Table, Pagination, message, Tooltip, Modal, Switch } from 'ant-design-vue';
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
import { FiveLuckyColumn } from '@/types/application/FiveLuckyGame';
import fiveLuckyApi from '@/api/application/fiveLuckyGame';
import { useDebounce } from '@/hooks/useDebounce';
import CDelModal from '@/components/CDelModal.vue';
import { RootModal } from '@/components/CDelModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

const aTable = Table;
const aPagination = Pagination;
const aTooltip = Tooltip;
const aSwitch = Switch;
const router = useRouter();

// 选择
const selectedRowKeys = ref<Key[]>([]);
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
};
const isDisabled = computed(() => (selectedRowKeys.value.length === 0 ? true : false));
// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 1, // 总页数
  options: ['10', '20', '30', '40', '50'], // 选项
});

const columns = [
  {
    title: '福卡名称',
    dataIndex: 'title',
    key: 'title',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '绑定直播间',
    dataIndex: 'studio_id',
    key: 'studio_id',
    align: 'center',
    ellipsis: true,
    slots: { customRender: 'bindStudioId' },
  },
  {
    title: '福卡设置',
    dataIndex: 'luckycardset',
    key: 'luckycardset',
    align: 'center',
    slots: { customRender: 'luckcardSet' },
  },
  {
    title: '福卡数量',
    dataIndex: 'max',
    key: 'max',
    align: 'center',
  },
  {
    title: '弹出时长',
    dataIndex: 'duration',
    key: 'duration',
    align: 'center',
    slots: { customRender: 'duration' },
  },
  {
    title: '中奖人数',
    dataIndex: 'num',
    key: 'num',
    align: 'center',
  },
  {
    title: '开关',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    slots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    align: 'center',
    width: 180,
    slots: { customRender: 'operation' },
  },
  {
    title: '数据统计',
    dataIndex: 'census',
    key: 'census',
    align: 'center',
    width: 200,
    slots: { customRender: 'census' },
  },
];
const list = ref<FiveLuckyColumn[]>([]);

const toRouter = (urlName: string) => {
  router.push({ name: urlName });
};

const showLoading = ref(true);
const getFiveLuckyList = useDebounce(() => {
  showLoading.value = true;
  const search = {
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
  };
  fiveLuckyApi
    .getFiveBlessing({ params: search })
    .then((res) => {
      if (res.data.data?.data) {
        const arr = res.data.data.data;
        list.value = arr.map((item: any) => {
          item.statusFetching = false;
          item.cardSwitchFetching = false;
          return item;
        });
        pageConfig.current = res.data.data.current_page;
        pageConfig.totalSize = res.data.data.total;
      } else {
        list.value = [];
        pageConfig.current = 1;
        pageConfig.totalSize = 1;
      }
    })
    .catch((err) => {
      message.error(err.data.error);
    })
    .finally(() => {
      showLoading.value = false;
    });
});
getFiveLuckyList();

// 删除
const delModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});

const openDelModal = () => {
  delModal.visible = !delModal.visible;
};
const removeLiveData = () => {
  delModal.loading = true;
  fiveLuckyApi
    .delfiveBlessing({ ids: selectedRowKeys.value })
    .then((res) => {
      message.success('操作成功！');
      selectedRowKeys.value = [];
      getFiveLuckyList();
    })
    .finally(() => {
      delModal.loading = false;
      delModal.visible = false;
    });
};

const edit = (item: FiveLuckyColumn) => {
  router.push({ name: 'FiveLuckyEdit', query: { id: item?.id } });
};

/**
 * 设置活动开启状态
 * @param item 五福对象
 * @param index 列表Index
 */
const setSwitch = (item: FiveLuckyColumn, index: number) => {
  const reqData = { ...item };
  reqData.status = Number(!reqData.status);
  list.value[index].statusFetching = true;
  fiveLuckyApi
    .editfiveBlessing(reqData)
    .then((res) => {
      list.value[index].status = reqData.status;
      message.success('操作成功！');
    })
    .catch((err) => {
      message.error(err.data.error);
    })
    .finally(() => {
      list.value[index].statusFetching = false;
    });
};

/**
 * 设置集齐福卡即开奖
 * @param item 五福对象
 * @param index 列表Index
 */
const setWinSwitch = (item: FiveLuckyColumn, index: number) => {
  const reqData = { ...item };
  reqData.card_win_switch = Number(!reqData.card_win_switch);
  list.value[index].cardSwitchFetching = true;
  fiveLuckyApi
    .editfiveBlessing(reqData)
    .then((res) => {
      list.value[index].card_win_switch = reqData.card_win_switch;
      message.success('操作成功！');
    })
    .catch((err) => {
      message.error(err.data.error);
    })
    .finally(() => {
      list.value[index].cardSwitchFetching = false;
    });
};

/**
 * 开奖
 * @param item 五福对象
 */
const openLucky = useDebounce((item: FiveLuckyColumn) => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: `确认开启抽奖？`,
    onOk() {
      return new Promise((resolve) => {
        fiveLuckyApi
          .openfiveBlessing({
            id: item?.id,
            status: 1,
          })
          .then((res) => {
            message.success('操作成功！');
            resolve({});
          })
          .catch((err: any) => {
            message.warn(err.data.error);
            resolve(err);
          });
      });
    },
  });
});

/**
 * 重置开奖
 * @param item 五福对象
 */
const resetLuck = useDebounce((item: FiveLuckyColumn) => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: `确认重置抽奖？`,
    onOk() {
      return new Promise((resolve) => {
        fiveLuckyApi
          .resetfiveBlessing({
            id: item?.id,
            studio_id: item.studio_id,
          })
          .then((res) => {
            message.success('操作成功！');
            resolve({});
          })
          .catch((err: any) => {
            message.warn(err.data.error);
            resolve(err);
          });
      });
    },
  });
});

const toUrl = (routerName: string, item: FiveLuckyColumn) => {
  router.push({ name: routerName, query: { id: item?.id } });
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toRouter('FiveLuckyAdd')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("新建活动")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          class: "mod_btn",
          type: "link",
          danger: "",
          disabled: _unref(isDisabled),
          onClick: openDelModal
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_btn_icon",
              "icon-class": "del"
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 删除 ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(aTable), {
        loading: showLoading.value,
        "row-selection": { selectedRowKeys: selectedRowKeys.value, onChange: onSelectChange },
        columns: columns,
        "data-source": list.value,
        pagination: false,
        "row-key": "id"
      }, {
        bindStudioId: _withCtx(({ record }) => [
          _createVNode(_component_router_link, {
            to: "/application/five_lucky/add",
            class: "link",
            onClick: ($event: any) => (edit(record))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(record.studio_name || '绑定'), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        luckcardSet: _withCtx(({ record }) => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "link",
            onClick: ($event: any) => (toUrl('LuckyCard', record))
          }, {
            default: _withCtx(() => [
              _createTextVNode("管理")
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        duration: _withCtx(({ record }) => [
          _createTextVNode(_toDisplayString(record.duration) + "S ", 1)
        ]),
        status: _withCtx(({ record, index }) => [
          _createVNode(_unref(aSwitch), {
            checked: record.status,
            loading: record?.statusFetching,
            "checked-value": 1,
            "un-checked-value": 0,
            onChange: ($event: any) => (setSwitch(record, index))
          }, null, 8, ["checked", "loading", "onChange"])
        ]),
        operation: _withCtx(({ record }) => [
          _createVNode(_unref(aTooltip), null, {
            title: _withCtx(() => [
              _createTextVNode(" 编辑 ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (edit(record))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "luckycard_edit" })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_unref(aTooltip), null, {
            title: _withCtx(() => [
              _createTextVNode(" 开奖 ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (_unref(openLucky)(record))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "luckycard_gift" })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_unref(aTooltip), null, {
            title: _withCtx(() => [
              _createTextVNode(" 重置 ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (_unref(resetLuck)(record))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "luckycard_refresh" })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        census: _withCtx(({ record }) => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "link",
            onClick: ($event: any) => (toUrl('LuckyCardRecord', record))
          }, {
            default: _withCtx(() => [
              _createTextVNode("福卡报告")
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "link",
            class: "link",
            onClick: ($event: any) => (toUrl('LuckyRecord', record))
          }, {
            default: _withCtx(() => [
              _createTextVNode("中奖报告")
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["loading", "row-selection", "data-source"]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(aPagination), {
          "show-quick-jumper": "",
          total: pageConfig.totalSize,
          current: pageConfig.current,
          "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => ((pageConfig.current) = $event)),
          "page-size": pageConfig.pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig.pageSize) = $event)),
          pageSizeOptions: pageConfig.options,
          "show-less-items": "",
          "show-size-changer": "",
          onChange: _unref(getFiveLuckyList),
          onShowSizeChange: _unref(getFiveLuckyList)
        }, null, 8, ["total", "current", "page-size", "pageSizeOptions", "onChange", "onShowSizeChange"])
      ], 512), [
        [_vShow, pageConfig.totalSize > pageConfig.pageSize]
      ]),
      _createVNode(CDelModal, {
        visible: delModal.visible,
        centered: "",
        close: openDelModal,
        ok: removeLiveData
      }, null, 8, ["visible"])
    ])
  ]))
}
}

})